import WrittenReview from './WrittenReview';
import ReviewRating from './ReviewRating';

import { makeStyles } from '@material-ui/core';

import { colorSet } from '@components/Provider';
import { FetchQuotationPartnerQuery } from '@generated/graphql';
import { CompanyInfoSection } from '../styled';

interface Props {
  data?: FetchQuotationPartnerQuery['fetchQuotationPartner']['data'];
}

const CompanyReview = ({ data }: Props) => {
  const classes = useStyles();

  const reviewInfo = data?.reviews ?? undefined;

  const reviewData = reviewInfo?.reviews ?? [];
  const noReview = reviewData.length === 0;

  if (noReview) return null;

  return (
    <CompanyInfoSection id="review" className={classes.root}>
      <ReviewRating reviewInfo={reviewInfo} />
      <WrittenReview reviewInfo={reviewInfo} />
    </CompanyInfoSection>
  );
};

const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: '26px 0px',
      [theme.breakpoints.down('xs')]: {
        padding: '24px 16px'
      }
    },
    header: {
      zIndex: 1010,
      height: 49,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'sticky',
      top: 0,
      padding: '12px 16px',
      borderBottom: `1px solid ${colorSet.gray400}`,
      backgroundColor: colorSet.gray000,
      '& button': {
        position: 'absolute',
        left: 16,
        width: 24,
        height: 24
      }
    }
  }),
  { classNamePrefix: 'review' }
);

export default CompanyReview;
